import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import Loader from '../../components/global/Loader'
import CommonBtn from '../../components/global/CommonBtn'
import BookingAlert from '../../components/global/BookingAlert'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import { globalKeyStore } from '../../redux/actions/globalState'
import { formatCardNumber } from '../../components/global/FormatString'
import { clearSessionDetails } from '../../utils/helper'

function PaymentFails({ dispatch, isLoading, systemErrorMessage, afterPaymentResponse, paymentStatus, systemError }) {

	const bookingFormPage = 2
	const navigate = useNavigate()
	const {facility} = useParams()
	const { pathname } = useLocation()
	const partnername = pathname?.split('/')?.filter(v => v != '')

	// total details for the payment and session and user 
	const localDetials = localStorage.getItem('bookingFormDetail') ? localStorage.getItem('bookingFormDetail') : '{}'
	const { personal_info, event_data } = JSON.parse(localDetials)
	const { name, email, phone } = (personal_info) ? personal_info : EMPTY_OBJECT

	useEffect(() => {
		dispatch(globalKeyStore({ isLoading: true }))
		// navigate()
		// to know the this the single event or pass 
		const passOrEvent = localStorage.getItem('selectEventType')
		const get_event_type = passOrEvent == 'event' ? passOrEvent : passOrEvent == 'pass' ? passOrEvent : ''
		const paymentErrorMessage = JSON.parse(localStorage.getItem('paymentResponse'))?.errors

		if ((paymentErrorMessage?.message)) {
			// payemnt response
			dispatch(globalKeyStore({ isLoading: false, systemErrorMessage: paymentErrorMessage?.message, paymentStatus: false, systemError: false, afterPaymentResponse: JSON.parse(localDetials) }))
			setTimeout(() => {
				clearSessionDetails()
			}, 3000)
		} else if (!name || name == '' || !email || email == '' || !get_event_type || get_event_type == '' || !event_data || event_data == '') {
			clearSessionDetails()
			if(facility){
				navigate(`/${partnername?.[0]}/${facility}`)

			}else{
				navigate(`/${partnername?.[0]}`)

			}
		} else {
			clearSessionDetails()
			if(facility){
				navigate(`/${partnername?.[0]}/${facility}`)

			}else{
				navigate(`/${partnername?.[0]}`)

			}
		}
	}, EMPTY_ARRAY)

	const backToDetail = () => {
		navigate(-1)
	}

	return (
		<div>
			{(isLoading) ? <div className='d-flex align-content-center flex-wrap vh-100 justify-content-center'><Loader /></div> :
			<div className="container my-5">
				<div className="position-relative m-4 mb-5">
					<div className="progress" role="progressbar" aria-label="Progress" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" style={{ height: '1px' }}>
						<div className="progress-bar" style={{ width: '50%' }}></div>
					</div>
					<CommonBtn isProgressBtn className={'position-absolute top-0 start-0 translate-middle btn btn-sm btn-primary rounded-pill'} value={'1'} style={{ width: '2rem', height: '2rem' }} />
					<CommonBtn isProgressBtn className={bookingFormPage == 1 || bookingFormPage == 2 ? 'position-absolute top-0 start-50 translate-middle btn btn-sm btn-primary rounded-pill' : 'position-absolute top-0 start-50 translate-middle btn btn-sm btn-secondary rounded-pill'} value={'2'} style={{ width: '2rem', height: '2rem' }} />
					<CommonBtn isProgressBtn className={bookingFormPage == 2 ? 'position-absolute top-0 start-100 translate-middle btn btn-sm btn-success rounded-pill' : 'position-absolute top-0 start-100 translate-middle btn btn-sm btn-secondary rounded-pill'} value={'3'} style={{ width: '2rem', height: '2rem' }} />
				</div>
				<div className='mb-3 d-flex justify-content-end'>
				<button type="button" onClick={backToDetail} className="btn btn-secondary"><i className="fa fa-chevron-circle-left"></i> Back</button>
				</div>
				<BookingAlert type='error' heading={paymentStatus} message={systemErrorMessage} />
				<main>
					{!systemError && <div className="container text-start">
						<div className="row justify-content-center">
							<div className="col-12 col-md-11">
								<hr />
								<h4 className="mb-4" style={{ marginLeft: 'left' }}>Booking Information</h4>
								<div className="row">
									<div className="col-sm-3">
										<small className='fw-bold'>Email Address</small>
										<p>{afterPaymentResponse?.personal_info?.email ? afterPaymentResponse?.personal_info?.email : email}</p>
									</div>
									<div className='col-auto d-none d-sm-block border-start'></div>
									<div className="col col-sm-3">
										<small className='fw-bold'>Phone Number</small>
										<p>{afterPaymentResponse?.personal_info?.phone ? afterPaymentResponse?.personal_info?.phone : phone}</p>
									</div>
									<div className='col-auto d-none d-sm-block border-start'></div>
									{(afterPaymentResponse?.payment_detail) && <div className="col col-sm-3">
										<small className='fw-bold'>Payment Card </small>
										<p><i className="fa fa-credit-card" aria-hidden="true"></i>{formatCardNumber(afterPaymentResponse?.payment_detail?.card_pan)} <span className="d-block"><i className="fa fa-calendar" aria-hidden="true"></i> {afterPaymentResponse?.payment_detail?.card_date_expiry_month}/{afterPaymentResponse?.payment_detail?.card_date_expiry_year}</span> </p>
									</div>}
								</div>
							</div>
						</div>
					</div>}
				</main>

			</div>}
		</div>
	)
}
PaymentFails.propTypes = {
	dispatch: PropTypes.func,
	notify: PropTypes.func,
	data: PropTypes.object,
	isLoading: PropTypes.bool,
	afterPaymentLoader: PropTypes.bool,
	systemErrorMessage: PropTypes.string,
	systemError: PropTypes.string,
	paymentStatus: PropTypes.string,
	afterPaymentResponse: PropTypes.object
}

PaymentFails.defaulProps = {
	dispatch: noop,
	notify: noop,
	data: EMPTY_OBJECT,
	isLoading: false,
	afterPaymentLoader: false,
	systemErrorMessage: '',
	systemError: '',
	paymentStatus: '',
	afterPaymentResponse: EMPTY_OBJECT
}

function mapStateToProps({ globalReducers }) {
	return {
		afterPaymentLoader: globalReducers?.afterPaymentLoader,
		systemErrorMessage: globalReducers?.systemErrorMessage,
		systemError: globalReducers?.systemError,
		paymentStatus: globalReducers?.paymentStatus,
		afterPaymentResponse: globalReducers?.afterPaymentResponse
	}
}
export default connect(mapStateToProps)(PaymentFails)
